import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fr_cookie_consent";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const choose = (value: "accepted" | "declined") => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* ignore */
    }
    (window as any).dataLayer?.push({ event: "cookie_consent", consent: value });
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-card text-card-foreground shadow-lg"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-4 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm leading-relaxed text-muted-foreground">
          <span>We use cookies to run the site and measure how it is used. See our </span>
          <Link to="/privacy" className="underline hover:text-foreground">
            Privacy Policy
          </Link>
          <span>.</span>
        </p>
        <div className="flex shrink-0 gap-2">
          <button
            type="button"
            onClick={() => choose("declined")}
            className="border border-border bg-background px-4 py-2 text-xs uppercase tracking-widest text-foreground transition-colors hover:bg-secondary"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={() => choose("accepted")}
            className="border border-accent-strong bg-accent-strong px-4 py-2 text-xs uppercase tracking-widest text-accent-foreground transition-opacity hover:opacity-90"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
